<template>
  <div id="team">
    <div class="header">
      <router-link :to="'/team/' + item.team.id" class="item">
        <!-- <div
          class="logo"
          :style="{ backgroundImage: 'url(' + item.club.shield + ')' }"
        ></div> -->

        <cld-image
          class="logo"
          :publicId="item.club.shield"
          type="fetch"
          loading="lazy"
        >
          <cld-transformation
            height="100"
            radius="3"
            crop="fill"
            fetchFormat="auto"
          />
        </cld-image>

        <div class="name">{{ item.club.name }} - {{ item.team.category }}</div>
      </router-link>

      <div class="action" @click="toggle()"></div>
    </div>
    <div v-if="expanded" class="content">
      <template v-if="last_match">
        <div class="title">{{ $t("miclive.competition.last_match") }}</div>
        <Match :item="last_match"></Match>
      </template>
      <template v-else> </template>

      <div class="title">{{ $t("miclive.competition.next_match") }}</div>
      <template v-if="next_match">
        <Match :item="next_match"></Match>
      </template>
      <template v-else>
        <div class="empty">{{ $t("miclive.competition.no_next_match") }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";

import Match from "@/components/domain/competition/match";
const api = new Api();

export default {
  name: "Team_following",
  props: {
    item: Object
  },
  components: { Match },
  data() {
    return {
      expanded: true,
      last_match: false,
      next_match: false
    };
  },
  computed: {},
  methods: {
    load() {
      var self = this;
      this.matches = false;
      var params = {
        teams_id: this.item.team.id
      };
      api.post("miclive/following", params).then(function(data) {
        self.last_match = Object.values(data.data)[0].last_match;
        self.next_match = Object.values(data.data)[0].next_match;
      });
    },
    toggle() {
      this.expanded = !this.expanded;
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
#team {
  margin-bottom: 10px;

  .header {
    background-color: $secondary-color;
    background-color: #fff;
    padding: 0 0px;
    height: 40px;
    overflow: hidden;
    display: grid;
    grid-template-columns: 10fr 1fr;
    border-radius: 4px;
    position: relative;
    // box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);

    .item {
      text-decoration: none;
      display: grid;
      grid-template-columns: 1fr 10fr;
      color: #222;

      .logo {
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 30px;
        padding: 5px;
        border-radius: 4px;
      }
      .name {
        width: 100%;
        line-height: 40px;
        font-size: 14px;
        font-family: $font-title;
        padding-left: 5px;
      }
    }

    .action {
      width: 40px;
      height: 40px;
      background-size: 12px;
      background-position: center right 15px;
      background-image: url("~@/../public/img/down.svg");
      background-repeat: no-repeat;
      background-color: #fff;
      background-color: $secondary-color;
      position: absolute;
      right: 0;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background-color: $main-color;
      }
    }
  }
  .content {
    padding: 10px 15px;
    // max-width: 400px;
    // margin: 0 auto;
    .title {
      font-size: 12px;
      margin-top: 10px;
      font-family: $font-text;
      text-align: center;
    }
    .empty {
      background: url("~@/../public/img/rest.svg") no-repeat top 10px center;
      background-size: 70px;
      width: 100%;
      height: 120px;
      padding-top: 100px;
      text-align: center;
      font-size: 12px;
    }
  }
}
</style>
